module.exports = "/fonts/h2h-logotype-d-fbea99864ef22e0c6e314cc241f27026.svg";